import { Theme } from '@mui/material';

export const getFlowChartColors = (tokens: Theme['palette']['tokens']) => ({
  STEP: {
    BACKGROUND: tokens.background.neutral.midToWhite[4],
    BACKGROUND_HOVER: tokens.background.neutral.midToWhite[3],
    BORDER: tokens.stroke.accent[1][3],
    BORDER_HOVER: tokens.stroke.accent[1][4],
  },
  TRANSITION: {
    BACKGROUND: tokens.background.accent[13][5],
    BACKGROUND_HOVER: tokens.background.accent[13][4],
    BORDER: tokens.stroke.accent[13].base,
    BORDER_HOVER: tokens.background.accent[13][1],
  },
  GROUP: {
    BACKGROUND: tokens.background.semantic.success[5],
    BORDER: tokens.stroke.semantic.success[1],
  },
  ERROR: {
    BACKGROUND: tokens.background.semantic.error[5],
    BORDER: tokens.stroke.semantic.error[1],
  },
  ALERT: {
    CRITICAL_BACKGROUND: tokens.background.semantic.error.base,
    CRITICAL_BORDER: tokens.stroke.semantic.error.base,
    HIGH_BACKGROUND: tokens.background.semantic.warning[5],
    HIGH_BORDER: tokens.stroke.semantic.warning[1],
    MEDIUM_BACKGROUND: tokens.background.semantic.suggest[5],
    MEDIUM_BORDER: tokens.stroke.semantic.suggest[1],
    LOW_BACKGROUND: tokens.background.semantic.info[5],
    LOW_BORDER: tokens.stroke.semantic.info[1],
    INFO_BACKGROUND: tokens.background.neutral.raised[5],
    INFO_BORDER: tokens.stroke.neutral[4],
    NO_SEVERITY_ICON: tokens.background.accent[9].base,
  },
  SECONDARY_TEXT: tokens.content.text.neutral[2],
});

export const STEP_NODE_WIDTH_PX = 320;
export const STEP_NODE_MAX_HEIGHT_PX = 110;
export const ALERT_NODE_WIDTH_PX = 130;
export const GROUP_NODE_WIDTH_PX = 340;
export const CR_TRANSITION_ARROW_WIDTH = 20;
export const CR_TRANSITION_ARROW_HEIGHT = 20;

// the space between nodes
export const NODE_SPACING = 160;
